// extracted by mini-css-extract-plugin
module.exports = {"exampleColorExport":"#5eccc3","breakpoint":"960px"};